import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, renderSlot as _renderSlot, createStaticVNode as _createStaticVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-44f8b139")

_pushScopeId("data-v-44f8b139")
const _hoisted_1 = { class: "FTLOrdersList" }
const _hoisted_2 = { class: "FTLOrdersList__header" }
const _hoisted_3 = { class: "header__left" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Скачать в Excel ")
const _hoisted_6 = { class: "FTLOrdersList__list scroll green" }
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<div class=\"list__header\" data-v-44f8b139><div class=\"list__row header\" data-v-44f8b139><div class=\"list__col first header\" data-v-44f8b139>Заказ</div><div class=\"list__col second header\" data-v-44f8b139>Номер заказа клиента</div><div class=\"list__col third header\" data-v-44f8b139>Статус заказа</div><div class=\"list__col fourth header\" data-v-44f8b139>Количество пунктов</div><div class=\"list__col fifth header\" data-v-44f8b139>Дата забора</div><div class=\"list__col sixth header\" data-v-44f8b139>Машина</div><div class=\"list__col seventh header\" data-v-44f8b139></div></div></div>", 1)
const _hoisted_8 = { class: "list__body" }
const _hoisted_9 = { class: "list__col first col-big" }
const _hoisted_10 = { class: "list__col second" }
const _hoisted_11 = { class: "list__col third" }
const _hoisted_12 = { class: "list__col fourth" }
const _hoisted_13 = { class: "list__col fifth" }
const _hoisted_14 = { class: "list__col sixth" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Подробнее ")
const _hoisted_16 = {
  key: 1,
  class: "list__row empty"
}
const _hoisted_17 = /*#__PURE__*/_createVNode("div", { class: "list__col full" }, "Нет заказов", -1)
const _hoisted_18 = {
  key: 1,
  class: "FTLOrdersList__loading"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_icon_refresh = _resolveComponent("icon-refresh")!
  const _component_s_button = _resolveComponent("s-button")!
  const _component_ftl_order_status = _resolveComponent("ftl-order-status")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_s_loader = _resolveComponent("s-loader")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("h2", _hoisted_4, _toDisplayString(_ctx.title), 1),
        (_ctx.withRefresh)
          ? (_openBlock(), _createBlock(_component_icon_refresh, {
              key: 0,
              class: "header__refresh",
              onClick: _ctx.emitRefresh
            }, null, 8, ["onClick"]))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_s_button, {
        class: "primary",
        onClick: _ctx.emitExcel
      }, {
        default: _withId(() => [
          _hoisted_5
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    (!_ctx.loading)
      ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
          _createVNode("div", _hoisted_6, [
            _hoisted_7,
            _createVNode("div", _hoisted_8, [
              (_ctx.orders && _ctx.orders.length > 0)
                ? (_openBlock(true), _createBlock(_Fragment, { key: 0 }, _renderList(_ctx.orders, (order, i) => {
                    return (_openBlock(), _createBlock("div", {
                      class: "list__row",
                      key: `FTLOrdersList-order-${i}`
                    }, [
                      _createVNode("div", _hoisted_9, _toDisplayString(order.id), 1),
                      _createVNode("div", _hoisted_10, _toDisplayString(order.dop_order_number), 1),
                      _createVNode("div", _hoisted_11, [
                        _createVNode(_component_ftl_order_status, {
                          "status-code": order.status_code,
                          "status-text": order.status
                        }, null, 8, ["status-code", "status-text"])
                      ]),
                      _createVNode("div", _hoisted_12, _toDisplayString(order.pointsSum) + " " + _toDisplayString(_ctx.declOfNum(order.pointsSum, _ctx.POINTS_TOKENS)), 1),
                      _createVNode("div", _hoisted_13, _toDisplayString(order.take_date), 1),
                      _createVNode("div", _hoisted_14, _toDisplayString(order.load_capacity), 1),
                      _createVNode(_component_router_link, {
                        to: `/order/ftl/${order.id}`,
                        class: "list__col seventh col-shadow"
                      }, {
                        default: _withId(() => [
                          _hoisted_15
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ]))
                  }), 128))
                : (_openBlock(), _createBlock("div", _hoisted_16, [
                    _hoisted_17
                  ]))
            ])
          ]),
          _renderSlot(_ctx.$slots, "default", {}, undefined, true)
        ], 64))
      : (_openBlock(), _createBlock("div", _hoisted_18, [
          _createVNode(_component_s_loader)
        ]))
  ]))
})